import { Box, styled, Typography } from '@mui/material';

import { useEffect, useRef, useState } from 'react';

import { ButtonStrings, Color } from '../../constants';

type ShowMoreTextProps = {
  text: string;
};

const MAX_LINES = 4;

const ShowMoreText = ({ text }: ShowMoreTextProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const [shouldShowButton, setShouldShowButton] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * MAX_LINES;

      setShouldShowButton(element.scrollHeight > maxHeight);
    }
  }, [text]);

  return (
    <Container>
      <StyledTypography ref={textRef} isExpanded={isExpanded}>
        {text}
      </StyledTypography>
      {shouldShowButton && (
        <ShowMoreButton onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? ButtonStrings.BUTTON_SHOW_LESS : ButtonStrings.BUTTON_SHOW_MORE}
        </ShowMoreButton>
      )}
    </Container>
  );
};

const Container = styled(Box)({
  display: 'inline-block',
});

const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})<{ isExpanded: boolean }>(({ isExpanded }) => ({
  display: isExpanded ? 'block' : '-webkit-box',
  WebkitLineClamp: isExpanded ? 'unset' : MAX_LINES,
  WebkitBoxOrient: 'vertical',
  overflow: isExpanded ? 'visible' : 'hidden',
  marginBottom: '4px',
}));

const ShowMoreButton = styled('span')({
  color: Color.darkCerulean,
  fontWeight: 500,
  fontSize: 16,
  cursor: 'pointer',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  textTransform: 'none',
  '&:hover': {
    color: Color.pelorous,
    backgroundColor: 'transparent',
  },
});

export default ShowMoreText;
